import { NgModule } from '@angular/core';

import { AppHeaderTitleQuotationService } from './app-header-title-quotation.service';
import { AppHeaderTitleService } from 'app/shared/components/app-header-title/app-header-title.service';
import { CommonModule } from '@angular/common';

@NgModule({
    providers: [
        AppHeaderTitleQuotationService
    ],
})
export class AppHeaderTitleQuotationModule { }
